export default "__VITE_ASSET__BV07BFXJ__"